(function() {
	'use strict';

	angular.module('widgets.buyer')
	.controller('buyerStdMyPrsToFirmCtrl', buyerStdMyPrsToFirmCtrl);

	function buyerStdMyPrsToFirmCtrl($scope, $rootScope, $timeout, $state, $experiments, dashboardFilterInitializationService,
			buyerStdMyPrsToFirmService) {
		$scope.$parent.$parent.showViewReport = true;
		$scope.slideshowView = $rootScope.slideshowView;
		$scope.loading = true;

		var columnDefinition = $scope.$parent.$parent.col;
		var curWidget = $scope.$parent.model;
		if (!$scope.slideshowView) {
			dashboardFilterInitializationService.markWidgetCreated('column' + columnDefinition.columnIndex, columnDefinition.widgets.indexOf(curWidget));
		}
		updateEventBind($scope, ['sideBarUpdate', 'slideshowViewChanged', 'inventoryFilterChanged']);

		function getChartData() {
			if (!dashboardFilterInitializationService.updating['initialLoad']) {
				updateDrilldown();
				buyerStdMyPrsToFirmService.getMyPrsToFirm().then(function(response) {
					$scope.loading = false;
					var data = _.merge({
						latePRCountUnder7: 0,
						latePRCountUnder14: 0,
						latePRCountOver14: 0,
						toFirmPRCount: 0
					}, response.data[0]);
					$scope.totalLate = data.latePRCountUnder7 + data.latePRCountUnder14 + data.latePRCountOver14;
					$scope.total =  $scope.totalLate + data.toFirmPRCount;
					$scope.data = data;
				}).catch(function(error) {
					$scope.error = 'Unable to retrieve data.';
					$scope.loading = false;
				});
			} else {
				$timeout(getChartData, 100);
			}
		}

		function updateDrilldown() {
			$scope.$parent.content.drillDownUrl = $state.href('app.supply-chain.purchase-requisitions') + buyerStdMyPrsToFirmService.getReactDrilldownFilterString();
		}

		getChartData();
	}
})();
